// extracted by mini-css-extract-plugin
module.exports = {"page_link":"Pagination_page_link__39rl2","pagination_container":"Pagination_pagination_container__3vSc-"};